/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from "react";
import { Socket } from "socket.io-client";
import {
  IAiDialogHistoryItem,
  IMlPart,
  IPractice,
  IPracticeStatus,
} from "../types/generalTypes";
import { IUser } from "./AuthContextProvider";
import { IMccUnit, IUnitNavMl, IUnitPin } from "../types/unitTypes";
import { IAddPickedTree } from "../modulez/admin/adminTypes";

// Context tipi
interface UnitContextType {
  pin: null | IUnitPin;
  setPinWithEmit: (newPin: IUnitPin) => void;
  canNavigate: boolean;
  unit: null | IMccUnit;
  currentMl: null | IUnitNavMl;
  currentMlParts: null | IMlPart[];
  currentPart: null | IMlPart;
  next: (args?: { preventEmit?: boolean }) => void;
  arePartsLoading: boolean;
  isLive: boolean;
  isUnitFinished: boolean;
}

// Auth Context oluşturma
export const UnitContext = createContext<UnitContextType>({
  pin: null,
  setPinWithEmit: () => { },
  canNavigate: false,
  unit: null,
  currentMl: null,
  currentMlParts: null,
  currentPart: null,
  next: () => { },
  arePartsLoading: false,
  isLive: false,
  isUnitFinished: false,
});

/*  */

export interface AuthContextType {
  user: null | IUser;
  isAuthenticated: boolean;
  login: (u: string) => void;
  logout: () => void;
  refreshUser: () => Promise<void>;
  isInstructor: boolean;
  isFulltimeSelfUser: boolean;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  isAuthenticated: false,
  login: (_u: string) => { },
  logout: () => { },
  refreshUser: async () => { },
  isInstructor: false,
  isFulltimeSelfUser: false,
});

/*  */

export interface PracticesContextType {
  practices: IPractice[];
  activePractice: null | IPractice;
  practiceIndex: number;
  setPracticeIndex: (s: number) => void;
  nextPractice: () => void;
  prevPractice: () => void;
  isLastPractice: boolean;
  isFirstPractice: boolean;
}

export const PracticesContext = createContext<PracticesContextType>({
  practices: [],
  activePractice: null,
  practiceIndex: 0,
  setPracticeIndex: () => null,
  nextPractice: () => null,
  prevPractice: () => null,
  isLastPractice: false,
  isFirstPractice: false,
});

/*  */

export interface ActivePracticeContextType {
  practice: IPractice | null;
  aiDialogHistory: Record<string, IAiDialogHistoryItem[]>;
  setAiDialogHistory: React.Dispatch<
    React.SetStateAction<Record<string, IAiDialogHistoryItem[]>>
  >;
  actionStatus: IPracticeStatus;
  setActionStatus: (
    n: IPracticeStatus | ((prev: IPracticeStatus) => IPracticeStatus)
  ) => void;
  sendAnswer: (formData: any) => void;
  wrongAnswerCount: number;
  setWrongAnswerCount: (n: number | ((prev: number) => number)) => void;
  isAnswerRevealed: boolean;
  setIsAnswerRevealed: (n: boolean | ((prev: boolean) => boolean)) => void;
  isInstructor: boolean
}

export const ActivePracticeContext = createContext<ActivePracticeContextType>({
  practice: null,
  aiDialogHistory: {},
  setAiDialogHistory: () => null,
  actionStatus: {
    ai: "IDLE",
    canGoNext: false,
    historyIndex: -1,
  },
  setActionStatus: () => null,
  sendAnswer: () => null,
  wrongAnswerCount: 0,
  setWrongAnswerCount: () => null,
  isAnswerRevealed: false,
  setIsAnswerRevealed: () => null,
  isInstructor: false
});

// SOCKET CONTEXT
export interface SocketContextType {
  socket: Socket | null;
  connectSocket: (user: IUser) => void;
  disconnectSocket: () => void;
  isConnected: boolean;
}

export const SocketContext = createContext<SocketContextType>({
  socket: null,
  connectSocket: () => { },
  disconnectSocket: () => { },
  isConnected: false,
});

/*  */

export interface ContentContext {
  pickedTree: IAddPickedTree;
  setPickedTree: (
    updater: IAddPickedTree | ((prev: IAddPickedTree) => IAddPickedTree)
  ) => void;
}

export const ContentContext = createContext<ContentContext>({
  pickedTree: { mlId: null, partId: null, unitId: null },
  setPickedTree: () => { },
});
